import { render, staticRenderFns } from "./UseCallCentersFilialsList.vue?vue&type=template&id=14357ba9&scoped=true&"
import script from "./UseCallCentersFilialsList.vue?vue&type=script&lang=js&"
export * from "./UseCallCentersFilialsList.vue?vue&type=script&lang=js&"
import style0 from "./UseCallCentersFilialsList.vue?vue&type=style&index=0&id=14357ba9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14357ba9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
